<div *ngIf="puntoCampionamento" class="flex justify-content-center w-12 gap-2">
  <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round px-2 py-1 bg-white">
    <div class="text-sm text-700 font-light">
      Regione
    </div>
    <div class="text-xl font-medium" *ngIf="puntoCampionamento.istatRegione<10">
      0{{puntoCampionamento.istatRegione}}
    </div>
    <div class="text-xl font-medium" *ngIf="puntoCampionamento.istatRegione>=10">
      {{puntoCampionamento.istatRegione}}
    </div>
    <div class="text-sm text-700 font-light">
      {{puntoCampionamento.regione?.denominazioneRegione}}
    </div>
  </div>
  <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round px-2 py-1 bg-white">
    <div class="text-sm text-700 font-light">
      Comune
    </div>
    <div class="text-xl font-medium ">
      {{puntoCampionamento.istatComune}}
    </div>
    <div *ngIf="puntoCampionamento.comune" class="text-sm text-700 font-light">
      {{puntoCampionamento.comune.denominazione}} ({{puntoCampionamento.comune.siglaAutomobolistica}})
    </div>
  </div>
  <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round px-2 py-1 bg-white">
    <div class="text-sm text-700 font-light">
      Tipologia
    </div>
    <div class="text-xl font-medium">
      {{puntoCampionamento.tipoPuntoCampionamento}}
    </div>
    <div class="text-sm text-700 font-light">
      {{puntoCampionamento.puntoCampionamentoTipologia?.descrizione}}
    </div>
  </div>
  <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round px-2 py-1 bg-white">
    <div class="text-sm text-700 font-light">
      Identificativo
    </div>
    <div class="text-xl font-medium">
      {{puntoCampionamento.idPuntoCampionamento}}
    </div>
    <div class="text-sm text-700 font-light">
      &nbsp;
    </div>
  </div>
  <div class="flex flex-column align-items-center justify-content-center border-1 surface-border border-round  px-2 py-1 bg-white">
    <div class="flex gap-3">
      <div class="text-sm text-700 font-medium">
        Punto di Campionamento  {{puntoCampionamento.dateStatus}}
      </div>
    </div>
    <div class="flex gap-3">
      <div class="text-sm text-700 font-medium">
        Data Inizio Validità
      </div>
      <div class="text-sm text-700 font-light">
        {{puntoCampionamento.dataInizioValidita | date: 'dd/MM/yyyy'}}
      </div>
    </div>
    <div class="text-sm text-700 font-light">
      &nbsp;
    </div>
    <div class="flex gap-3">
      <div class="text-sm text-700 font-medium">
        Data fine Validità
      </div>
      <div class="text-sm text-700 font-light">
        {{puntoCampionamento.dataFineValidita | date: 'dd/MM/yyyy'}}
      </div>
    </div>
  </div>
</div>
